import React from 'react'
import { Typewriter } from 'react-simple-typewriter'

const Home = () => {
  return (
    <section className="text-blue body-font bg-gradient-to-r from-cyan-200 via-blue-300 to-blue-600">
      <div className="container mx-auto flex md:flex-row flex-col items-center pt-20">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-5xl text-5xl mb-4 font-medium text-blue">
            Bitnea
            <Typewriter
              words={[' Marketing Digital', ' Desarrollo Web', ' Social Media Marketing']}
              loop={15}
              cursor
              cursorStyle="_"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
            <br className="hidden lg:inline-block" />
          </h1>
          <p className="mb-8 leading-relaxed mt-12">
            Transformamos tu presencia digital con estrategias efectivas y soluciones personalizadas.
            <br />
            Impulsa tu negocio al siguiente nivel.
          </p>
          <div className="flex justify-center">
            <a
              href="#planes"
              className="inline-flex text-blue-900 bg-white border border-white py-2 px-8 focus:outline-none hover:bg-blue-700 hover:text-white rounded-full text-lg transition-colors duration-300"
            >
              Ver Planes
            </a>
            <a
              href="#cotizar"
              className="ml-4 inline-flex text-gray-700 bg-gray-200 border-0 py-2 px-8 focus:outline-none hover:bg-gray-300 rounded-full text-lg transition-colors duration-300"
            >
              Cotizar
            </a>
          </div>
        </div>
        <div className="relative">
          <img
            className="w-24 ml-24 absolute elements animate-bounce"
            src="https://c.tenor.com/6R6CUEXJGkAAAAAi/favorite-instagram.gif"
            alt="Decorative element"
          />
          <img
            className="max-w-2xl w-full"
            alt="hero"
            src="https://i.ibb.co/h2z72dZ/business-finance-and-employment-female-successful-entrepreneurs-concept-cheerful-successful-business.png"
          />
        </div>
      </div>
    </section>
  )
}

export default Home
